/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RestoreSkillVersionRequestBody,
  RestoreSkillVersionRequestBody$Outbound,
  RestoreSkillVersionRequestBody$outboundSchema,
} from "../components/restoreskillversionrequestbody.js";

export type RestoreSkillVersionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RestoreSkillVersionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RestoreSkillVersionSecurity = {
  option1?: RestoreSkillVersionSecurityOption1 | undefined;
  option2?: RestoreSkillVersionSecurityOption2 | undefined;
};

export type RestoreSkillVersionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  restoreSkillVersionRequestBody: RestoreSkillVersionRequestBody;
};

/** @internal */
export type RestoreSkillVersionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RestoreSkillVersionSecurityOption1$outboundSchema: z.ZodMiniType<
  RestoreSkillVersionSecurityOption1$Outbound,
  RestoreSkillVersionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function restoreSkillVersionSecurityOption1ToJSON(
  restoreSkillVersionSecurityOption1: RestoreSkillVersionSecurityOption1,
): string {
  return JSON.stringify(
    RestoreSkillVersionSecurityOption1$outboundSchema.parse(
      restoreSkillVersionSecurityOption1,
    ),
  );
}

/** @internal */
export type RestoreSkillVersionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RestoreSkillVersionSecurityOption2$outboundSchema: z.ZodMiniType<
  RestoreSkillVersionSecurityOption2$Outbound,
  RestoreSkillVersionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function restoreSkillVersionSecurityOption2ToJSON(
  restoreSkillVersionSecurityOption2: RestoreSkillVersionSecurityOption2,
): string {
  return JSON.stringify(
    RestoreSkillVersionSecurityOption2$outboundSchema.parse(
      restoreSkillVersionSecurityOption2,
    ),
  );
}

/** @internal */
export type RestoreSkillVersionSecurity$Outbound = {
  Option1?: RestoreSkillVersionSecurityOption1$Outbound | undefined;
  Option2?: RestoreSkillVersionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RestoreSkillVersionSecurity$outboundSchema: z.ZodMiniType<
  RestoreSkillVersionSecurity$Outbound,
  RestoreSkillVersionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RestoreSkillVersionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RestoreSkillVersionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function restoreSkillVersionSecurityToJSON(
  restoreSkillVersionSecurity: RestoreSkillVersionSecurity,
): string {
  return JSON.stringify(
    RestoreSkillVersionSecurity$outboundSchema.parse(
      restoreSkillVersionSecurity,
    ),
  );
}

/** @internal */
export type RestoreSkillVersionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RestoreSkillVersionRequestBody: RestoreSkillVersionRequestBody$Outbound;
};

/** @internal */
export const RestoreSkillVersionRequest$outboundSchema: z.ZodMiniType<
  RestoreSkillVersionRequest$Outbound,
  RestoreSkillVersionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    restoreSkillVersionRequestBody:
      RestoreSkillVersionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      restoreSkillVersionRequestBody: "RestoreSkillVersionRequestBody",
    });
  }),
);

export function restoreSkillVersionRequestToJSON(
  restoreSkillVersionRequest: RestoreSkillVersionRequest,
): string {
  return JSON.stringify(
    RestoreSkillVersionRequest$outboundSchema.parse(restoreSkillVersionRequest),
  );
}
